import { useCallback } from "react";

import { useSelector } from "react-redux";

import { holdParticipant } from "Services/ConversationsApiService";
import {
    selectSnapshotConferenceFriendlyID,
    selectSnapShotConferenceSid,
    selectConferenceSnapshotSingularActiveParticipant,
} from "Services/state/conferences/ConferenceSnapshotSelectors";

export type UseHoldCallResult = { onHold: boolean; toggleHold: () => Promise<unknown>; holdDisabled?: boolean };

export const useCallActionHold = (): UseHoldCallResult => {
    const snapshotConferenceFriendlyId = useSelector(selectSnapshotConferenceFriendlyID);
    const snapshotConferenceSid = useSelector(selectSnapShotConferenceSid);

    const participant = useSelector(selectConferenceSnapshotSingularActiveParticipant);
    // @ts-expect-error deal with this not being a queue
    const callSid = participant?.callSid;
    const snapshotOnHold = !!participant?.hold;
    const snapHoldDisabled = !(callSid && snapshotConferenceSid && snapshotConferenceFriendlyId);

    // there seems to be a slight race condition where we participant
    // BUT NOT callSid or the conferenceFriendlyId.
    // this will keep the button disabled so we dont get a server error.
    const snapshotToggleHold = useCallback(() => {
        return holdParticipant({
            conferenceSid: snapshotConferenceSid,
            conferenceFriendlyId: snapshotConferenceFriendlyId,
            callSid: callSid,
            hold: !participant?.hold,
        });
    }, [callSid, participant?.hold, snapshotConferenceFriendlyId, snapshotConferenceSid]);

    return { onHold: snapshotOnHold, toggleHold: snapshotToggleHold, holdDisabled: snapHoldDisabled };
};
